import React, { Component } from 'react';
import {
    Modal, Form, Input,
} from 'antd';

const FormItem = Form.Item;

class UnwrappedRefillAmountModal extends Component {
    render() {
        const {
            visible, onCancel, onCreate, form,
        } = this.props;

        const { getFieldDecorator } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 9 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 11 },
            },
        };

        return (
            <Modal
                visible={visible}
                title="Add Amount"
                style={{ textAlign: 'center', fontSize: '1.2em' }}
                okText="Submit"
                onCancel={onCancel}
                onOk={onCreate}
            >
                <Form>
                    <FormItem
                        {...formItemLayout}
                        label="Bill Amount"
                    >

                        {getFieldDecorator('bill_amount', {
                            rules: [{ required: true, message: '$$$' }],
                            min: 1,
                        })(
                            <Input min={1} style={{ width: '100%' }} />,
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}

const RefillAmountModal = Form.create()(UnwrappedRefillAmountModal);


export default RefillAmountModal;



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/RefillAmountModal.js